module.exports = new __parcel__URL__("paintbucket.43d76d3b.jpg").toString();